import { useSelector } from "react-redux";

import { selectCstic } from "~/features/configurator/Linear/redux/selectCstic";
import { SimpleCsticId } from "~/features/configurator/Linear/models";
import * as UnitCstic from "~/features/configurator/Linear/v2/configuration/kuem/KUEMUnitCstics";

import { Box } from "~/common/mui";
import { lazy } from "react";
import { NumberFormatter } from "~/common/utils/NumberFormatter";

const WideImage = lazy(() => import("./KUEMWideImage"));
const StandardImage = lazy(() => import("./KUEMStandardImage"));

export const KUEMGuidewaySetHeader = () => {
  const guidewayDesign = useSelector(selectCstic(SimpleCsticId(UnitCstic.GuidewayDesign)));
  const sizeCode = useSelector(selectCstic(SimpleCsticId(UnitCstic.SizeCode)));

  const guidewayLength = +(useSelector(selectCstic(SimpleCsticId(UnitCstic.GuidewayLength)))?.value ?? 0);
  const al = +(useSelector(selectCstic(SimpleCsticId(UnitCstic.AL)))?.value ?? 0);
  const ar = +(useSelector(selectCstic(SimpleCsticId(UnitCstic.AR)))?.value ?? 0);
  const jl = +(useSelector(selectCstic(SimpleCsticId(UnitCstic.AlarHardMax)))?.value ?? 0);
  const jb = 23;

  const NF = NumberFormatter.getFormatter();
  const lengthValue = `L = ${NF.format(guidewayLength)}mm`;
  const alValue = `aL = ${NF.format(al)}mm`;
  const arValue = `aR = ${NF.format(ar)}mm`;
  const jbValue = `jB = ${NF.format(jb)}mm`;
  const jlValue = `jL = ${NF.format(jl)}mm`;

  const props = {
    guidewayLength: lengthValue,
    al: alValue,
    ar: arValue,
    jb: jbValue,
    jl: jlValue,
  };

  const showWide = guidewayDesign.value === "W" && sizeCode.value === "15";

  return (
    <Box sx={{ width: "100%", aspectRatio: "659 / 359" }}>
      {showWide ? <WideImage {...props} /> : <StandardImage {...props} />}
    </Box>
  );
};

export interface ImageProps {
  guidewayLength: string;
  al: string;
  ar: string;
  jb: string;
  jl: string;
}

export default KUEMGuidewaySetHeader;
